var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c(
          "router-link",
          { attrs: { to: "profissionais/" + _vm.professional.accountable.id } },
          [
            _c("img", {
              staticClass: "profile-img",
              attrs: { src: _vm.professional.profile.profile_picture }
            })
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "name" }, [
          _c("span", { staticClass: "first-name" }, [
            _vm._v(_vm._s(_vm.professional.first_name))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "last-name" }, [
            _vm._v(_vm._s(_vm.professional.last_name))
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "copy",
          attrs: { src: "/static/copy.svg" },
          on: {
            click: function($event) {
              return _vm.sendDataToClipboard(_vm.fullName)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "infos" }, [
      _c("div", { staticClass: "content-info" }, [
        _c("span", [
          _c("b", [_vm._v("Email:")]),
          _vm._v(" " + _vm._s(_vm.professional.email))
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "copy small",
          attrs: { src: "/static/copy.svg" },
          on: {
            click: function($event) {
              return _vm.sendDataToClipboard(_vm.professional.email)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-info" }, [
        _c("span", [
          _c("b", [_vm._v("Cidade:")]),
          _vm._v(" " + _vm._s(_vm.professional.profile.city_name))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-info" }, [
        _c("span", [
          _c("b", [_vm._v("CPF:")]),
          _vm._v(" " + _vm._s(_vm.professional.accountable.cpf))
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "copy small",
          attrs: { src: "/static/copy.svg" },
          on: {
            click: function($event) {
              return _vm.sendDataToClipboard(_vm.professional.accountable.cpf)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-info" }, [
        _c("span", [
          _c("b", [_vm._v("MEI:")]),
          _vm._v(" " + _vm._s(_vm.professional.accountable.mei || "n/a"))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-info" }, [
        _c("span", [
          _c("b", [_vm._v("Criado em:")]),
          _vm._v(
            " " + _vm._s(_vm._f("formatDate")(_vm.professional.created_at))
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45df27e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45df27e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfessionalRegisterFlow/components/Card.vue
// module id = null
// module chunks = 